var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSell = function SvgSell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sell_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sell_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 21.4q-.575.575-1.425.575T11.4 21.4l-8.8-8.8q-.276-.275-.437-.65a2 2 0 0 1-.163-.8V4q0-.824.587-1.412A1.93 1.93 0 0 1 4 2h7.15q.425 0 .8.163.375.162.65.437l8.8 8.825q.575.575.575 1.412a1.92 1.92 0 0 1-.575 1.413zM12.825 20l7.15-7.15L11.15 4H4v7.15zM6.5 8q.624 0 1.063-.437Q8 7.125 8 6.5t-.437-1.062A1.45 1.45 0 0 0 6.5 5q-.625 0-1.062.438A1.45 1.45 0 0 0 5 6.5q0 .624.438 1.063Q5.874 8 6.5 8"
  }))));
};
export default SvgSell;